import React from 'react';

const NavbarStyles: React.FC = () => {
  return (
    <style>{`
      @keyframes fadeInDown {
        0% {
          opacity: 0;
          transform: translateY(-15px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
      
      @keyframes fadeOutUp {
        0% {
          opacity: 1;
          transform: translateY(0);
        }
        100% {
          opacity: 0;
          transform: translateY(-15px);
        }
      }
      
      .animate-fadeIn {
        animation: fadeInDown 0.3s ease-out forwards;
      }
      
      /* Smooth hover transitions */
      .nav-item:hover {
        transform: translateY(-1px);
      }
    `}</style>
  );
};

export default NavbarStyles;